
import { MainLayout } from "@/components/layout/MainLayout";
import { Link } from "react-router-dom";

export default function Courses() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Μαθήματα</h1>
        <p className="text-muted-foreground">
          Εκπαιδευτικά μαθήματα για τα μέλη της Web Star. Επιλέξτε μια από τις κατηγορίες στα αριστερά.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="border rounded-lg p-6 hover:bg-accent transition-colors">
            <h2 className="text-xl font-semibold mb-2">Βίντεο Μαθήματα</h2>
            <p className="text-sm text-muted-foreground mb-4">Εκπαιδευτικά βίντεο για διάφορα θέματα τεχνολογίας.</p>
            <Link to="/courses/videos" className="text-primary hover:underline">Δείτε όλα τα βίντεο →</Link>
          </div>
          <div className="border rounded-lg p-6 hover:bg-accent transition-colors">
            <h2 className="text-xl font-semibold mb-2">Διαδραστικά Μαθήματα</h2>
            <p className="text-sm text-muted-foreground mb-4">Διαδραστικά μαθήματα με ασκήσεις και παραδείγματα.</p>
            <Link to="/courses/interactive" className="text-primary hover:underline">Δείτε όλα τα διαδραστικά μαθήματα →</Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
